module.exports = __webpack_public_path__ + "static/media/bodyIcons.cbf54351.svg";